/**
 * Global polygon fill visibility for map rendering paths that cannot receive a direct
 * dependency injection (canvas VT tiles, shared vector-tile utils).
 */
let polygonFillVisible = true;

export function isMapPolygonFillVisible(): boolean {
  return polygonFillVisible;
}

export function setMapPolygonFillVisible(visible: boolean): void {
  polygonFillVisible = visible;
}

/** Leaflet map event fired after {@link setMapPolygonFillVisible} from {@link VisibilityManager}. */
export const OSM_POLYGON_FILL_VISIBILITY_EVENT = 'osm:polygonFillVisibility' as const;
